import styled from "styled-components";
import { media } from "../../theme/theme";
import { MarketingSpacing } from "../ReusableStyledComponents/MarketingSpacing";
import { H2, Body } from "../Typography";

const BRDESKTOP = 1000;

export const PledgeOffset = styled.div<{ hasDesktopImg: boolean }>`
    ${media.custom(BRDESKTOP)} {
        padding-top: ${({ hasDesktopImg }) => hasDesktopImg ? "45px" : null};
    }
`;

export const PledgeWrapper = styled.div<{ hasDesktopImg: boolean, skipBackground?: boolean }>`
    width: 100%;
    background: ${({ skipBackground, theme }) => !skipBackground ? theme.marketing.colors.blackPearl30 : null};
    padding: 45px 0;

    ${media.custom(BRDESKTOP)} {
        padding: ${({ hasDesktopImg }) => hasDesktopImg ? "75px 0" : "60px 0"};
    }
`;

export const PledgeContainer = styled.div<{ hasDesktopImg: boolean }>`
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    position: relative;
    ${MarketingSpacing}

    ${media.custom(BRDESKTOP)} {
        max-width: ${({ hasDesktopImg }) => hasDesktopImg ? "1140px" : "900px"};
    }

    ${H2} { 
        text-align: center;
        color:  ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};
        margin-bottom: 25px;

        ${media.custom(BRDESKTOP)} {
            text-align: ${({ hasDesktopImg }) => hasDesktopImg ? "left" : "center"};
        }
    }

    ${Body} {
        text-align: center;
        color:  ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
        margin-bottom: 30px;

        ${media.custom(BRDESKTOP)} {
            text-align: ${({ hasDesktopImg }) => hasDesktopImg ? "left" : "center"};
            margin-bottom: ${({ hasDesktopImg }) => !hasDesktopImg ? "30px" : "0px"};
        }
    }

    > div {
        &:nth-child(1) {
            ${media.custom(BRDESKTOP)} {
                max-width: ${({ hasDesktopImg }) => hasDesktopImg ? "488px" : null};
            }
        }

        &:nth-child(2) {
            display: none;

            ${media.custom(BRDESKTOP)} {
                display: block;
            }

            img {
                position: absolute;
                bottom: -75px;
                right: 0;
                max-width: 606px;
            }
        }
    }
`;

export const PledgeAvatar = styled.div<{ hasDesktopImg: boolean }>`
    border-radius: 50%;
    width: 94px;
    height: 94px;
    margin: 0 auto;
    overflow: hidden;
    display: block;

    ${media.custom(BRDESKTOP)} {
        display: ${({ hasDesktopImg }) => hasDesktopImg ? "none" : null};
    }

    > img {
        width: 100%;
        height: auto;
    }
`;